export const CATEGORY_META = {
  personality: { label: "Personality", color: "bg-[#FEF08A]", hex: "#FEF08A" },
  aptitude: { label: "Aptitude", color: "bg-[#A7F3D0]", hex: "#A7F3D0" },
  interest: { label: "Interest", color: "bg-[#E9D5FF]", hex: "#E9D5FF" },
  mental_ability: { label: "Mental Ability", color: "bg-[#FFDDBF]", hex: "#FFDDBF" },
};
